<form class="drop-padding" [formGroup]="createForm" (ngSubmit)="create()">
  <mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput type="text" formControlName="description" />
  </mat-form-field>
  <button color="primary" mat-flat-button type="submit">Создать</button>
</form>
